import React from "react";
import { Box, Typography, Card, CardContent, Grid } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const achievements = [
  {
    title: "Best Performer Award",
    year: "2024",
    description: "Recognized for outstanding performance in project delivery and client satisfaction.",
  },
  {
    title: "React Certification",
    year: "2023",
    description: "Completed advanced React certification from Coursera.",
  },
  {
    title: "Hackathon Winner",
    year: "2022",
    description: "Won first prize in college-level hackathon for building a smart waste management system.",
  },
];

const Achievements = () => {
  return (
    <Box sx={{ py: 6 }}>
      {/* <Typography fontWeight="bold" mb={4} textAlign="center">
        🏆 Achievements
      </Typography> */}

      <h1 className="section__title mb-3">🏆 Achievements</h1>

      <Grid container spacing={3}>
        {achievements.map((item, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                boxShadow: 3,
                transition: "0.3s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: 6,
                },
              }}
            >
              <CardContent>
                <EmojiEventsIcon color="warning" sx={{ fontSize: 40 }} />

                <Typography variant="h6" fontWeight="600" mt={1}>
                  {item.title}
                </Typography>

                <Typography variant="body2" color="text.secondary" mb={1}>
                  {item.year}
                </Typography>

                <Typography variant="body2">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Achievements;